import React,{ useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import SendMoneyForm from '../../components/forms/SendMoneyForm/SendMoneyForm';

const SendMoney = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="send-money">
      <SendMoneyForm userId={uid} />
    </AuthLayout>
  );
};

export default SendMoney;
